import PropTypes from 'prop-types';
import { GRAPH_COPY } from './graph/graphConstants';

/**
 * The ultimate owners the collapse hides, with 'Show all owners': below the levels table and the
 * phone list, which have no Ultimate shareholders table to list them (the graph view has).
 * Renders nothing without such owners or without the action.
 *
 * @param {Object} props
 * @param {number} [props.count] - PreparedGraph.hiddenUltimateCount
 * @param {() => void} [props.onExpandAllOwners] - 'Show all owners'
 * @param {string} [props.className]
 */
const HiddenUltimatesNote = ({ count = 0, onExpandAllOwners, className }) =>
  count > 0 && onExpandAllOwners ? (
    <p className={className}>
      {GRAPH_COPY.HIDDEN_ULTIMATES(count)}{' '}
      <button type="button" className="sg-link-button" onClick={onExpandAllOwners}>
        {GRAPH_COPY.SHOW_ALL_OWNERS}
      </button>
    </p>
  ) : null;

HiddenUltimatesNote.propTypes = {
  count: PropTypes.number,
  onExpandAllOwners: PropTypes.func,
  className: PropTypes.string
};

export default HiddenUltimatesNote;
